<template>
  <div class="project-outbox">
    <div class="project">
      <div class="title">资源管理</div>
      <div class="pro-info">
        <div class="right">
          <el-input v-model="form.searchName" prefix-icon="el-icon-search" clearable placeholder="请输入资源名称"></el-input>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        </div>
        <div class="left">
          <el-button type="primary" @click="goAddRole">添加资源</el-button>
        </div>
      </div>
      <div class="table">
        <div class="table_bd">
          <el-table v-loading="tableLoading" :data="tableData" max-height="100%">
            <el-table-column type="index" label="编号" width="70">
            </el-table-column>
            <el-table-column prop="resourceNameShow" label="权限名称" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="resourceName" label="权限别名" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="resourceUrl" label="接口" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="resourceType" label="小类型" show-overflow-tooltip :formatter="resourceTypeFormat" align="center">
            </el-table-column>
            <el-table-column prop="isH5" label="是否是H5" show-overflow-tooltip :formatter="isH5Format" align="center">
            </el-table-column>
            <el-table-column prop="parentId" label="上级名称" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="isShow" label="是否展示" show-overflow-tooltip :formatter="isShowFormat" align="center">
            </el-table-column>
            <el-table-column prop="equipmentType" label="设备类型" show-overflow-tooltip :formatter="equipmentTypeFormat" align="center">
            </el-table-column>
            <el-table-column prop="address" label="编辑" align="center">
              <template slot-scope="scope">
                <el-button class="text-primary" @click="handleEditClick(scope.row)" type="text" size="small">
                  编辑
                </el-button>
                <el-button class="text-danger" @click="handleDelClick(scope.row)" type="text" size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="m-t-lg" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" align="right" background :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Message
} from 'element-ui';
export default {
  name: "accessMange",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      form: {
        searchName: "",
      },
      fitType: "fill",
      treeLoading: false,
      RoleResources: [],
      roleSelectIds: [],
      tableLoading: true,
      defaultProps: {
        children: "children",
        label: "resourceNameShow",
      },
      type: 0,
      typeTitle: "添加角色",
      roleForm: {
        id: 0,
        roleName: "",
        roleDescribe: "",
      },
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
      tableData: [],
      roleId: 0,
    };
  },
  created() {
    this.searchResourceList();
  },
  methods: {
    searchResourceList() {
      this.tableLoading = true;
      // 获取权限列表
      const params = {
        currentPage: this.currentPage,
        resourceName: this.form.searchName,
        size: this.pageSize,
      };
      this.$http
        .post("bma-user-service/resource/searchResourceList", params)
        .then((res) => {
          const data = res.data;
          this.tableData = data.records;
          this.total = data.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.tableLoading = false;
        });
    },
    handleEditClick(data) {
      console.log(data);
      this.$router.push({
        path: "/super/addresource",
        query: { type: 1, id: data.id },
      });
    },
    handleDelClick(row) {
      // 删除
      const that = this;
      that
        .$confirm("确定要删除此资源吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.$http
            .post("bma-user-service/resource/deleteResource", {
              resourceId: row.id,
            })
            .then(function (res) {
              console.log(res);
              Message({
                showClose: true,
                message: res.data,
                type: "success",
              });
              that.searchResourceList();
            })
            .catch(function (err) {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchResourceList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchResourceList();
    },
    goAddRole(res) {
      this.$router.push({
        path: "/super/addresource",
        query: { type: 0 },
      });
    },
    onSearch() {
      this.currentPage = 1;
      this.searchResourceList();
    },
    // 表格筛选信息
    stateFormat(row, column, cellValue) {
      if (!cellValue) {
        return "未填写";
      } else {
        return cellValue;
      }
    },
    resourceTypeFormat(row, column, cellValue) {
      let SwitchName = "";
      switch (cellValue) {
        case 1:
          SwitchName = "平台";
          break;
        case 2:
          SwitchName = "子系统";
          break;
        case 3:
          SwitchName = "模块";
          break;
        case 4:
          SwitchName = "菜单";
          break;
        case 5:
          SwitchName = "功能";
          break;
        case 6:
          SwitchName = "按钮";
          break;
        case 7:
          SwitchName = "菜单下按钮";
          break;
        default:
          SwitchName = " ";
      }
      return SwitchName;
    },
    isH5Format(row, column, cellValue) {
      let SwitchName = "";
      switch (cellValue) {
        case 0:
          SwitchName = "不是";
          break;
        case 1:
          SwitchName = "是";
          break;
        default:
          SwitchName = " ";
      }
      return SwitchName;
    },
    isShowFormat(row, column, cellValue) {
      let SwitchName = "";
      switch (cellValue) {
        case 0:
          SwitchName = "不展示";
          break;
        case 1:
          SwitchName = "展示";
          break;
        default:
          SwitchName = " ";
      }
      return SwitchName;
    },
    equipmentTypeFormat(row, column, cellValue) {
      let SwitchName = "";
      switch (cellValue) {
        case 1:
          SwitchName = "app";
          break;
        case 2:
          SwitchName = "web";
          break;
        default:
          SwitchName = " ";
      }
      return SwitchName;
    },
  },
};
</script>
<style lang="less" scoped>
#tree_list ul {
  padding-left: 40px;
}
.project-outbox {
  padding: 20px;
}
.project {
  background: #f8f8f9;
  border-radius: 7px;
  padding: 24px;
  .title {
    font-size: 18px;
    color: #0e223d;
    letter-spacing: 2px;
    font-weight: 600;
  }
  .pro-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 28px;

    position: relative;
    z-index: 2000;
    .left {
      font-size: 16px;
      color: #0e223d;
      span {
        &:last-of-type {
          font-weight: 600;
        }
      }
    }
    .right {
      display: flex;
      .el-input {
        margin-right: 10px;
      }
      .search {
        margin-right: 20px;
      }
    }
  }
  .table-box {
    .el-table {
      background: rgba(0, 0, 0, 0);
      th,
      tr {
        background: rgba(0, 0, 0, 0);
      }
      th {
        > .cell {
          color: #152139;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }
      }
      tr {
        td {
          text-align: center;
          font-size: 14px;
          color: #152139;
        }
      }
      .btn-out-box {
        display: flex;
        justify-content: space-around;
      }
      .btn-box {
        width: 24px;
        height: 24px;
        background: rgba(165, 165, 165, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .iconfont {
          font-size: 12px;
          color: rgba(195, 195, 195, 1);
        }
        &.download.active {
          background: rgba(31, 207, 138, 0.1);
          .iconfont {
            color: rgba(31, 207, 138, 1);
          }
        }
        &.editself.active {
          background: rgba(20, 96, 224, 0.1);
          .iconfont {
            color: rgba(20, 96, 224, 1);
          }
        }
      }
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 30px;
  }
  .el-dialog {
    width: 35%;
    .el-dialog__title {
      font-weight: 600;
    }
    .el-input {
      // width: 323px;
    }
    .line {
      text-align: center;
    }
  }
}
</style>